import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { PatientDocumentTypeDto, UpsertPatientDocumentTypeDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/patient-document-type`;

export const getAllPatientDocumentTypes = (
    source: CancelTokenSource)
    : Promise<Array<PatientDocumentTypeDto>> => {

  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
}

export const getPatientDocumentType = (
    code: string, source: CancelTokenSource)
    : Promise<UpsertPatientDocumentTypeDto> => {

  return axios
      .get(`${apiUri}/${code}`, {cancelToken: source.token})
      .then(response => response.data);
}

export const addPatientDocumentType = (
    code: string,
    upsertPatientDocumentType: UpsertPatientDocumentTypeDto,
    source: CancelTokenSource)
    : Promise<PatientDocumentTypeDto> => {

  return axios
      .post(`${apiUri}/${code}`, upsertPatientDocumentType, {cancelToken: source.token})
      .then(response => response.data);
}

export const editPatientDocumentType = (
    code: string,
    upsertPatientDocumentType: UpsertPatientDocumentTypeDto,
    source: CancelTokenSource)
    : Promise<PatientDocumentTypeDto> => {

  return axios
      .put(`${apiUri}/${code}`, upsertPatientDocumentType, {cancelToken: source.token})
      .then(response => response.data);
}
